import React from 'react';
import { PageTitle } from '../components/PageTitle';
import { Sitemap } from '../components/Sitemap';
export function SitemapPage() {
  return <div className="bg-white min-h-screen" data-id="element-1450">
      <PageTitle title="Sitemap" canonical="/sitemap" description="A complete overview of Katalina Bock's professional portfolio website structure and navigation." keywords="sitemap, website structure, Katalina Bock, portfolio navigation" data-id="element-1451" />
      <section className="bg-gradient-to-r from-[#E0F5F8] to-[#F0FAFC] text-gray-900 py-12" data-id="element-1452">
        <div className="container mx-auto px-4" data-id="element-1453">
          <h1 className="text-4xl font-bold mb-4" data-id="element-1454">Sitemap</h1>
          <p className="text-xl text-gray-700 max-w-3xl" data-id="element-1455">
            A complete overview of my website's structure to help you navigate
            to the information you need.
          </p>
        </div>
      </section>
      <Sitemap data-id="element-1456" />
    </div>;
}